import { render } from "./PortalSettingsMyBoard.vue?vue&type=template&id=3c3df4e4&scoped=true"
import script from "./PortalSettingsMyBoard.vue?vue&type=script&lang=js"
export * from "./PortalSettingsMyBoard.vue?vue&type=script&lang=js"

import "./PortalSettingsMyBoard.vue?vue&type=style&index=0&id=3c3df4e4&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3df4e4"]])

export default __exports__